import { AiOutlineUser } from "react-icons/ai";
import "./myDashboard.css";
import { useState } from "react";
import logout from "../methods/api/logout";
import updateUser from "../methods/api/updateUser";
const MyDashboard = ({ user }) => {
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validatePassword()) {
      alert("Hasła się nie zgadzają!");
      return;
    }

    await updateUser(formData.password).then((status) => {
      if (status === 204) {
        logout().then((status) => {
          if (status === 200) {
            window.localStorage.removeItem("token");
            window.location.href = "/login";
          } else {
            alert("Błąd serwera!")
          }
        });
      } else {
        alert("Operacja nie powiodła się!");
      }
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const validatePassword = () => {
    return formData.password === formData.confirmPassword;
  };
  return (
    <main>
      <h2 className="subpage-title">MOJE DANE</h2>
      <div className={"my-dashboard-wrapper"}>
        <div className={"my-dashboard"}>
          <div className={"user-section"}>
            <AiOutlineUser size={100} />
            <div className={"user-data"}>
              <h2>{user.username}</h2>
              <h3>{user.role === "admin" ? "Administrator" : "Użytkownik"}</h3>
            </div>
          </div>
          <form
            onSubmit={handleSubmit}
            className="change-password-form"
            id="change-password-form"
          >
            <label for="username">
              <b>NAZWA UŻYTKOWNIKA</b>
            </label>
            <input type="text" value={user.username} name="username" disabled />

            <label for="password">
              <b>NOWE HASŁO</b>
            </label>
            <input
              type="password"
              placeholder="Proszę wpisać hasło..."
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <input
              type="password"
              placeholder="Proszę powtórzyć hasło..."
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
            />

            <button type="submit">ZMIEŃ HASŁO</button>
          </form>
        </div>
      </div>
    </main>
  );
};

export default MyDashboard;
